import { IServerResponse, getFirstChildNode, IXmlNode } from '@/app-modules/server-communications';
import { safeCast } from '@/helper';
import { BaseResponse } from '@/components/chat/_domain/server/base-response';

class UserListResponse extends BaseResponse<UserListResponse> {
  public users: UserResponse[];
  public userCount: number;

  constructor(messageNode?: IXmlNode) {
    super();
    if (messageNode) {
      this.users = (messageNode.childNodes.user || []).map((user) => new UserResponse(user));
      this.userCount = safeCast(messageNode.attributes.quantity, 0);
    }
  }

  protected filter(response: IServerResponse): boolean {
    return /command="userlist"/g.test(response.Contents);
  }

  protected map(response: IServerResponse): UserListResponse {
    const node: Nullable<IXmlNode> = getFirstChildNode(response.Contents);
    if (node === null) {
      throw new Error('Failed to map response');
    }

    return new UserListResponse(node);
  }
}

class UserResponse {
  public username: string;
  public newMember: boolean;
  public chatPrize: boolean;
  public notEligibleForPromo: boolean;
  public notEligibleForChatPrize: boolean;
  public returningPlayer: boolean;
  public birthday: boolean;
  public twiceSinned: boolean;
  public quantity: number;
  public troubleMaker: boolean;
  public client: string;
  public clientType: string;

  constructor(messageNode: IXmlNode) {
    this.username = messageNode.attributes.username;
    this.newMember = safeCast(messageNode.attributes.newmember, false);
    this.chatPrize = safeCast(messageNode.attributes.chatprize, false);
    this.notEligibleForPromo = !safeCast(messageNode.attributes.iseligibleforpromo, true);
    this.notEligibleForChatPrize = !safeCast(messageNode.attributes.iseligibleforchatprize, true);
    this.returningPlayer = safeCast(messageNode.attributes.returningplayer, false);
    this.birthday = safeCast(messageNode.attributes.birthday, false);
    this.twiceSinned = safeCast(messageNode.attributes.twicesinned, false);
    this.quantity = safeCast(messageNode.attributes.quantity, 0);
    this.troubleMaker = safeCast(messageNode.attributes.troublemaker, false);
    this.client = messageNode.attributes.client;
    this.clientType = messageNode.attributes.clienttype;
  }
}

export { UserListResponse, UserResponse };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/server/user-list-response.ts